import React from "react";
import { BlocksCards, BlockCard, BlockCardDescription, BlockCardImg } from "../../shared";
import messages from "./messages";
import { FormattedMessage } from "react-intl";
import SlideIcon from "../../../../icons/homeNav/Slide";
import MapIcon from "../../../../icons/homeNav/Map";
import DashboardsIcon from "../../../../icons/homeNav/Dashboards";
import BulkExportIcon from "../../../../icons/homeNav/BulkExport";

export const HomeNavigationBlocks = () => (
  <BlocksCards>
    <BlockCard to="/slides">
      <BlockCardImg blockIndex={1}>
        <SlideIcon />
      </BlockCardImg>
      <BlockCardDescription>
        <FormattedMessage {...messages.slides} />
        <FormattedMessage {...messages.slidesDescription} />
      </BlockCardDescription>
    </BlockCard>
    <BlockCard to="/maps">
      <BlockCardImg blockIndex={2}>
        <MapIcon />
      </BlockCardImg>
      <BlockCardDescription>
        <FormattedMessage {...messages.maps} />
        <FormattedMessage {...messages.mapsDescription} />
      </BlockCardDescription>
    </BlockCard>
    <BlockCard to="/dashboards" disabled>
      <BlockCardImg blockIndex={3}>
        <DashboardsIcon />
      </BlockCardImg>
      <BlockCardDescription>
        <FormattedMessage {...messages.dashboards} />
        <FormattedMessage {...messages.dashboardsDescription} />
      </BlockCardDescription>
    </BlockCard>
    <BlockCard to="/bulk-export">
      <BlockCardImg blockIndex={4}>
        <BulkExportIcon />
      </BlockCardImg>
      <BlockCardDescription>
        <FormattedMessage {...messages.bulkExport} />
        <FormattedMessage {...messages.bulkExportDescription} />
      </BlockCardDescription>
    </BlockCard>
  </BlocksCards>
);

export default HomeNavigationBlocks;
